import React from 'react';

import { ArrowCheckIcon } from '@sharedCR/coreDesignSystem/icons';

import { IconDirection, IconSize } from 'constants/coreDesignSystem';

export const treeViewSlots = {
  collapseIcon: () => <ArrowCheckIcon direction={IconDirection.DOWN} size={IconSize[18]} />,
  expandIcon: () => <ArrowCheckIcon direction={IconDirection.RIGHT} size={IconSize[18]} />,
};
